/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useRef, useEffect } from 'react';
import { useGLTF } from '@react-three/drei';
import _ from 'lodash';
import { Color } from 'three';

function ObjectHighlighter({ nodes, reference, position, scale, color, rotation, polygonOffset, polygonOffsetFactor, polygonOffsetUnits }) {
  const ref = useRef();
  const meshes = nodes;
  useEffect(() => {
    ref.current.children.forEach((mesh) => {
      // Clone material to avoid mutating shared GLTF material
      const cloned = mesh.material.clone();
      cloned.map = mesh.material.map; // preserve texture

      if (color !== undefined) {
        const tint = new Color(color);
        // Apply to base color so the whole lamella is tinted, not just the edges.
        cloned.color.copy(tint);
        cloned.emissive.copy(tint);
        cloned.emissiveIntensity = 0.07; // subtle overlay without washing out texture
      }

      cloned.transparent = true;
      cloned.opacity = 1;
      cloned.fog = false;
      cloned.metalness = mesh.material.metalness ?? 0.5;
      cloned.roughness = mesh.material.roughness ?? 0.6;
      if (polygonOffset) {
        cloned.polygonOffset = true;
        cloned.polygonOffsetFactor = polygonOffsetFactor ?? 1;
        cloned.polygonOffsetUnits = polygonOffsetUnits ?? 1;
      }
      cloned.needsUpdate = true;

      mesh.material = cloned;
    });
  }, [color, polygonOffset, polygonOffsetFactor, polygonOffsetUnits]);

  return (
    <group ref={ref} position={position} scale={scale} rotation={rotation}>
      {meshes.map(({ uuid, geometry, material }) => (
        <mesh castShadow receiveShadow key={uuid} ref={reference} geometry={geometry} material={material} />
      ))}
    </group>
  );
}

function getColor(color, identifier) {
  if (color === undefined) {
    return undefined;
  } else {
    return parseInt(color, 16);
  }
}

export function WoodOutlinedColoredBeam(props) {
  // console.log('WoodOutlinedColored props: ', props);
  const { nodes, materials } = useGLTF('/WoodOutlinedColored.glb');
  const color = getColor(_.get(props, 'color', 0));

  const resolvedRotation = Array.isArray(props.rotation) && props.rotation.length === 3 ? props.rotation : [0, props.rotation || 0, 0];

  return (
    <group dispose={null}>
      <ObjectHighlighter
        key={props?.id ? props?.id : 'lamella'}
        name={'lamella'}
        nodes={[nodes.Cube]}
        material={materials['Material.001']}
        color={color} // Use the color retrieved from getColorFromString
        position={props.position}
        scale={props.scale}
        rotation={resolvedRotation}
        polygonOffset={props.polygonOffset}
        polygonOffsetFactor={props.polygonOffsetFactor}
        polygonOffsetUnits={props.polygonOffsetUnits}
      />
    </group>
  );
}

useGLTF.preload('/WoodOutlinedColored.glb');
